import React, { Fragment, useRef, useState, useEffect } from "react";
import Papa from "papaparse";

import { Dialog, Transition } from "@headlessui/react";
import { useParams, useNavigate } from "react-router-dom";

import Config from "../../utils/Config";
import { useSelector, useDispatch } from "react-redux";
import swal from "sweetalert";

import Spinner from "../../assets/spinner/spinner.gif";
import ExcelLogo from "../../assets/mse-excel-logo.png";
import UploadIcon from "../../assets/upload-icon.png";
import { FaPlus, FaMinus } from "react-icons/fa";

import { ScenarioContext } from "../../utils/Context";

import { setHomer } from "../../redux/slices/helperSlice";

// KIT recommendation
import useFetchData from "../hooks/useFetchData";
const COMPONENT_KEYS = [
  "solar-product",
  "inverter-product",
  "generator-product",
  "battery-product",
  "mounting-product",
  "chargecontroller-product",
];

const COMPONENT_LABELS = {
  "solar-product": "Solar Product",
  "inverter-product": "Inverter Product",
  "generator-product": "Generator Product",
  "battery-product": "Battery Product",
  "mounting-product": "Mounting Product",
  "chargecontroller-product": "Charge Controller",
};

const UNIT_LABELS = {
  "solar-product": "kW",
  "inverter-product": "kW",
  "generator-product": "kW",
  "battery-product": "kWh",
  "mounting-product": "modules",
  "chargecontroller-product": "kW",
};

const DEFAULT_PRODUCT_NAMES = {
  "solar-product": "S48MT",
  "inverter-product": "ISP27",
  "generator-product": "PGP35",
  "battery-product": "B3.8LFP",
  "mounting-product": "C2Box",
  "chargecontroller-product": "MPPT-100-600",
};

export default function Hero() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.profile);
  const { uploadHomerAsyn } = React.useContext(ScenarioContext);

  // KIT Recommendation
  const { data: productsData } = useFetchData(
    "/products?sort_by=id&sort_direction=asc"
  );
  const [products, setProducts] = useState({});
  const [selections, setSelections] = useState({});
  const [storing, setStoring] = useState(false);

  const calculateRequiredQuantity = (product, targetCapacity, key) => {
    if (key === "mounting-product") return 1;

    const unitKey = `${key.replace("-", "_")}_unit_capacity`;
    const unitCapacity = product?.[unitKey] || 0;

    if (unitCapacity <= 0) return 1;

    if (key === "chargecontroller-product") {
      return Math.floor((solarPVCapacity * 0.8) / unitCapacity);
    }

    return Math.ceil(targetCapacity / unitCapacity);
  };

  const handleProductChange = (category, newId) => {
    const selected = products[category]?.data.find(
      (p) => p.id === parseInt(newId)
    );

    let target = 1;
    if (category === "solar-product") target = solarPVCapacity;
    else if (category === "battery-product") target = batteryStorageCapacity;
    else if (category === "inverter-product") target = batteryInverterCapacity;
    else if (category === "generator-product") target = generatorSize;

    const quantity = calculateRequiredQuantity(selected, target, category);

    setSelections((prev) => ({
      ...prev,
      [category]: {
        product: selected,
        quantity,
      },
    }));
  };

  const handleQuantityChange = (category, newQty) => {
    setSelections((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        quantity: parseInt(newQty) || 1,
      },
    }));
  };

  // Accordion
  const [openSection, setOpenSection] = useState("techno");
  const cancelButtonRef = useRef(null);
  const homer_file = React.useRef(null);

  const navigate = useNavigate();
  const { site_id } = useParams();

  const [scenarioName, setScenarioName] = React.useState("");
  const [PVTilt, setPVTilt] = React.useState(0);
  const [PVAzimuth, setPVAzimuth] = React.useState(0);
  const [solarPVCapacity, setSolarPVCapacity] = React.useState(0);
  const [batteryStorageCapacity, setBatteryStorageCapacity] = React.useState(0);
  const [batteryInverterCapacity, setBatteryInverterCapacity] =
    React.useState(0);
  const [generatorSize, setGeneratorSize] = React.useState(0);
  const [renewableFraction, setRenewableFraction] = React.useState(0);
  const [generatorRuntime, setGeneratorRuntime] = React.useState(0);
  const [fuelConsumption, setFuelConsumption] = React.useState(0);

  const [generatorQuantity, setGeneratorQuantity] = React.useState(0);

  const [fuelTankSize, setFuelTankSize] = React.useState(0);

  const [loading, setLoading] = React.useState(false);
  // const [ uploading, setUploading ] = React.useState(false);
  // const [ uploadProgress, setUploadProgress] = React.useState(0);
  // const [ uploadReport, setUploadReport] = React.useState("");

  const { uploading, uploadProgress, uploadReport, homer } = useSelector(
    (state) => state.helper
  );

  const [fileUploadInstructionsModel, setFileUploadInstructionsModel] =
    useState(false);

  const [solarProduct] = React.useState({
    id: 7,
    solar_product_name: "S48MT",
    solar_product_quantity: 1,
    solar_product_label: "S48MT",
    solar_product_unit_capacity: 25.44,
    solar_product_total_capacity: 25.44,
    solar_product_unit_cost: 29360,
    solar_product_notes: "48 panel BoxPower SolarContainer",
    solar_product_manufacturer: "BoxPower",
    solar_product_model: "S48MT",
    solar_product_part_number: "S48MT",
    solar_product_certifications: "UL 1703",
    solar_product_tilt: 30,
    solar_product_azimuth: 180,
    solar_product_string_length: 8,
    solar_product_string_quantity: 6,
    solar_product_pmax: 25440,
    solar_product_vmp: 325.6,
    solar_product_imp: 64.92,
    solar_product_voc: 389.6,
    solar_product_isc: 68.88,
    solar_product_voc_min_temp: 368,
    solar_product_isc_min_temp: 55.56,
    others: null,
    created_at: "2024-02-08T03:05:49.000000Z",
    updated_at: "2024-02-08T03:05:49.000000Z",
  });
  const [batteryProduct] = React.useState({
    id: 1,
    battery_product_name: "B3.8LFP",
    battery_product_quantity: 1,
    battery_product_label: "B3.8LFP",
    battery_product_unit_capacity: 3.8,
    battery_product_total_capacity: 3.8,
    battery_product_unit_cost: 20000,
    battery_product_notes: "BoxPower 3.8kWh battery",
    battery_product_manufacturer: "BoxPower",
    battery_product_model: "B3.8LFP",
    battery_product_part_number: "B3.8LFP",
    battery_product_certifications: "UL 1642, UL 1973, UL 9540A",
    battery_product_chemistry: "Lithium Ferro Phosphate (LFP)",
    battery_product_dc_voltage: 51.2,
    battery_product_amp_hours: 75,
    battery_product_storage_capacity: 3.8,
    battery_product_max_discharge_rate: 1.9,
    battery_product_max_charge_rate: 1.9,
    battery_product_discharge_depth: 100,
    others: null,
    created_at: "2024-02-08T19:42:50.000000Z",
    updated_at: "2024-02-08T19:42:50.000000Z",
  });
  const [inverterProduct] = React.useState({
    id: 5,
    inverter_product_name: "ISP27",
    inverter_product_quantity: 1,
    inverter_product_label: "ISP27",
    inverter_product_unit_capacity: 27.2,
    inverter_product_total_capacity: 27.2,
    inverter_product_unit_cost: 28793,
    inverter_product_notes: "Single phase system with 4 schneider conext pro",
    inverter_product_manufacturer: "BoxPower",
    inverter_product_model: "ISP27",
    inverter_product_part_number: "ISP27",
    inverter_product_certifications: "UL1741",
    inverter_product_output_power: 27200,
    inverter_product_output_voltage: "120/240",
    inverter_product_output_frequency: "60",
    inverter_product_max_input_current: 720,
    inverter_product_max_output_current: 140,
    others: null,
    created_at: "2024-02-08T03:39:16.000000Z",
    updated_at: "2024-02-08T03:39:16.000000Z",
  });
  const [mountingProduct] = React.useState({
    id: 2,
    mounting_product_name: "C2Box",
    mounting_product_quantity: 1,
    mounting_product_label: "C2Box",
    mounting_product_unit_capacity: 60,
    mounting_product_total_capacity: 60,
    mounting_product_unit_cost: 20660,
    mounting_product_notes: "C2Box - Enclosure",
    mounting_product_manufacturer: "BoxPower",
    mounting_product_model: "C2Box",
    mounting_product_part_number: "C2Box",
    mounting_product_certifications: "ISO 6346",
    mounting_min_clear_height: 20,
    others: null,
    created_at: "2024-02-08T20:15:50.000000Z",
    updated_at: "2024-02-08T20:15:50.000000Z",
  });
  const [generatorProduct] = React.useState({
    id: 2,
    generator_product_name: "PGP35",
    generator_product_quantity: 1,
    generator_product_label: "PGP35",
    generator_product_unit_capacity: 35,
    generator_product_total_capacity: 35,
    generator_product_unit_cost: 21933,
    generator_product_notes: "35 kW prime-power-rated propane generator",
    generator_product_manufacturer: "BoxPower",
    generator_product_model: "PGP35",
    generator_product_part_number: "PGP35",
    generator_product_certifications: "UL 2200, UL 6200, UL 1236, UL 489",
    generator_frequency: "60",
    generator_phase: "Single-Phase, Three-Phase",
    generator_rated_voltage: "120/208/240/277/480",
    generator_real_standby_power: 35,
    generator_apparent_standby_power: 44,
    generator_real_prime_power: 32,
    generator_apparent_prime_power: 39,
    generator_power_factor: 0.8,
    generator_efficiency: 90,
    generator_max_current: 146,
    generator_continuous_current: 131,
    generator_breaker_current: 150,
    others: null,
    created_at: "2024-02-08T21:12:31.000000Z",
    updated_at: "2024-02-08T21:12:31.000000Z",
  });
  const [chargecontrollerProduct] = React.useState({
    id: 3,
    chargecontroller_product_name: "MPPT-100-600",
    chargecontroller_product_quantity: 1,
    chargecontroller_product_label: "MPPT-100-600",
    chargecontroller_product_unit_capacity: 6,
    chargecontroller_product_total_capacity: 6,
    chargecontroller_product_unit_cost: 3200,
    chargecontroller_product_notes: "6 kW MPPT 100 600",
    chargecontroller_product_manufacturer: "Schneider",
    chargecontroller_product_model: "MPPT-100-600",
    chargecontroller_product_part_number: "865-1034",
    chargecontroller_product_certifications: "UL1741, CSA 107.1",
    chargecontroller_max_pv_capacity: 6,
    chargecontroller_max_string_length: 10,
    others: null,
    created_at: "2024-02-08T21:36:11.000000Z",
    updated_at: "2024-02-08T21:36:11.000000Z",
  });

  const [fenceProduct] = React.useState({
    id: 1,
    fence_product_height: 0,
    fence_product_type: "",
    fence_product_topper: "",
    fence_product_sound_attenuation: "",
    fence_product_attenuation_spec: "",
    fence_product_manufacturer: "",
    fence_product_model: "",
    fence_product_part_number: "",
    others: [],
  });

  const [optimizationType, setOptimizationType] = React.useState("HOMER"); // HOMER, NREL

  const [microgridSystemSizingType, setMicrogridSystemSizingType] =
    React.useState("homer-optimization-results"); // homer-optimization-results, microgrid-optimization-feature
  const [microgridSystemSizingStage, setMicrogridSystemSizingStage] =
    React.useState(1);

  const [scenario, setScenario] = React.useState({});

  const [editOptimizationSummaryModel, setEditOptimizationSummaryModel] =
    useState(false);
  const [loadingEditOptimizationSummary, setLoadingEditOptimizationSummary] =
    React.useState(false);

  React.useEffect(() => {
    dispatch(setHomer(null));
    loadProducts();
  }, [user, navigate]);

  const loadProducts = () => {
    setLoading(true);
    fetch(`${Config.API.URL}/products?page=${1}&limit=10`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    })
      .then((res) => {
        setLoading(false);

        // if 401 error (unauthenticated user, then log user out)
        if (res.status === 401) {
          console.log("401 Error: Unauthenticated");
          localStorage.removeItem("user");
          navigate("/");
        }
        return res;
      })
      .then((res) => res.json())
      .then(async (res) => {
        setLoading(false);
        console.log("init-res:", res.data);

        if (res.status) {
        } else {
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error: ", error);
      });
  };

  const submitScenarios = () => {
    if (scenarioName.length) {
      setLoading(true);
      const payload = {
        site_id: site_id,
        scenario_name: scenarioName,
        optimization_type: optimizationType,
        pv_tilt: PVTilt ? PVTilt : 0,
        pv_azimuth: PVAzimuth ? PVAzimuth : 0,
        solar_pv_capacity: solarPVCapacity ? solarPVCapacity : 0,
        battery_storage_capacity: batteryStorageCapacity
          ? batteryStorageCapacity
          : 0,
        battery_inverter_capacity: batteryInverterCapacity
          ? batteryInverterCapacity
          : 0,
        generator_quantity: generatorQuantity ? generatorQuantity : 0,
        generator_size: generatorSize ? generatorSize : 0,
        model_renewable_fraction: renewableFraction ? renewableFraction : 0,
        generator_runtime: generatorRuntime ? generatorRuntime : 0,
        fuel_consumption: fuelConsumption ? fuelConsumption : 0,
        fuel_tank_size: fuelTankSize ? fuelTankSize : 0,
        solar_product: [],
        battery_product: [],
        inverter_product: [],
        mounting_product: [],
        generator_product: [],
        chargecontroller_product: [],
        fence_product: [],
        partner_id: user.partner_id,
      };

      fetch(`${Config.API.URL}/scenarios`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          setLoading(false);
          // if 401 error (unauthenticated user, then log user out)
          if (res.status === 401) {
            console.log("401 Error: Unauthenticated");

            localStorage.removeItem("user");
            navigate("/");
          }
          return res;
        })
        .then((res) => res.json())
        .then(async (res) => {
          setLoading(false);
          //console.log('res:', res);
          // if request is succesful, alert user that project has been cloned
          if (res.status) {
            setScenario(res.data);
            if (optimizationType === "NREL") {
              const optimizationURL = Config.production
                ? `https://optimization.boxpower.cloud/site-information?site=${site_id}&scenario=${res.data.id}&ref=v2`
                : `https://dev-optimization.boxpower.cloud/site-information?site=${site_id}&scenario=${res.data.id}&ref=v2`;

              window.open(optimizationURL, "_blank", "noopener,noreferrer");
              navigate(`/scenarios/view/${site_id}`);
            } else {
              setMicrogridSystemSizingStage(2);
            }
            // navigate(`/scenarios/view/${site_id}`);
          } else {
            //swal("Oh no!", res.message, "error");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error: ", error);

          /*swal(
            "Oh no!",
            "An error occured!!! while connecting to server. Please try again",
            "error"
          );*/
        });
    } else {
      swal("Oh no!", "All fields with asterisk(*) are required", "error");
    }
  };

  const handleSave = () => {
    setStoring(true);
    const buildProductPayload = (categoryKey) => {
      const entry = selections[categoryKey];
      if (!entry || !entry.product) return [];

      const nameKey = `${categoryKey.replace("-", "_")}_name`;
      const unitKey = `${categoryKey.replace("-", "_")}_unit_capacity`;
      const labelKey = `${categoryKey.replace("-", "_")}_label`;
      const quantityKey = `${categoryKey.replace("-", "_")}_quantity`;
      const totalCapacityKey = `${categoryKey.replace(
        "-",
        "_"
      )}_total_capacity`;

      const quantity = entry.quantity || 1;
      const unitCapacity = entry.product[unitKey] || 0;
      const totalCapacity = (unitCapacity * quantity).toFixed(2);
      const label = entry.product[nameKey];

      // Attach calculated values to the product object (shallow copy)
      return [
        {
          ...entry.product,
          [quantityKey]: quantity,
          [totalCapacityKey]: totalCapacity,
          [labelKey]: label,
        },
      ];
    };

    const payload = {
      pv_tilt: PVTilt,
      pv_azimuth: PVAzimuth,
      solar_pv_capacity: solarPVCapacity,
      battery_storage_capacity: batteryStorageCapacity,
      battery_inverter_capacity: batteryInverterCapacity,
      generator_quantity: generatorQuantity,
      generator_size: generatorSize,
      model_renewable_fraction: renewableFraction,
      generator_runtime: generatorRuntime,
      fuel_consumption: fuelConsumption,
      fuel_tank_size: fuelTankSize,
      solar_product: buildProductPayload("solar-product"),
      inverter_product: buildProductPayload("inverter-product"),
      generator_product: buildProductPayload("generator-product"),
      battery_product: buildProductPayload("battery-product"),
      mounting_product: buildProductPayload("mounting-product"),
      chargecontroller_product: buildProductPayload("chargecontroller-product"),
    };

    fetch(`${Config.API.URL}/scenarios/${scenario?.id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          setStoring(false);
          swal("Success", "Products saved successfully", "success").then(() => {
            navigate(`/scenarios/optimization/${site_id}/${scenario.id}`);
          });
        } else {
          swal("Error", res.message || "An error occurred.", "error");
        }
      })
      .catch((err) => {
        console.error(err);
        swal("Error", "Failed to connect to server.", "error");
      });
  };

  const triggerUploadHomer = () => {
    //$('#upload-homer-file').trigger('click');
    document.getElementById("upload-homer-file").click();
  };

  // Updated uploadHomer function
  const uploadHomer = (e) => {
    const file = e.target.files[0];

    if (!file) {
      swal("Oh no!", "Please select a HOMER file to continue", "error");
      return;
    }

    if (!file.name.toLowerCase().endsWith(".csv")) {
      swal("Invalid File", "Please upload a valid CSV file.", "error");
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        const data = results.data;

        // Estimate values
        const estimates = estimateScenarioFromHomer(data);

        setSolarPVCapacity(estimates.solarPVCapacity || 0);
        setBatteryStorageCapacity(estimates.batteryStorageCapacity || 0);
        setBatteryInverterCapacity(estimates.batteryInverterCapacity || 0);
        setGeneratorSize(estimates.generatorSize || 0);
        setRenewableFraction(estimates.renewableFraction || 0);
        setGeneratorRuntime(estimates.generatorRuntime || 0);
        setFuelConsumption(estimates.fuelConsumption || 0);
        //console.log("Fuel Consumption: ", estimates.fuelConsumption);
        if (estimates.solarPVCapacity > 0) {
          setPVTilt(30);
          setPVAzimuth(180);
        } else {
          setPVTilt(0);
          setPVAzimuth(0);
        }
        if (estimates.generatorRuntime > 0) {
          setFuelTankSize(1000);
          setGeneratorQuantity(2);
        } else {
          setFuelTankSize(0);
          setGeneratorQuantity(0);
        }

        // Upload to backend
        const formData = new FormData();
        formData.append("scenario_id", scenario?.id);
        formData.append("file", file);
        uploadHomerAsyn(formData, user);
      },
      error: function (err) {
        console.error("CSV parsing error:", err);
        swal("Error", "Failed to parse the HOMER file", "error");
      },
    });
  };

  // Add helper function inside Hero component
  function estimateScenarioFromHomer(data) {
    const get = (row, key) => parseFloat(row[key]) || 0;

    const solarPVCapacity = Math.max(
      ...data.map((row) => get(row, "Solar Power Output"))
    );
    const batteryStorageCapacity = Math.max(
      ...data.map((row) => get(row, "Battery Energy Content"))
    );
    const batteryInverterCapacity = Math.max(
      ...data.map((row) => get(row, "Battery Discharge Power"))
    );
    const generatorSize = Math.max(
      ...data.map((row) => get(row, "Generator Power Output"))
    );
    const renewableVals = data.map((row) => get(row, "Renewable Penetration"));
    const renewableFraction =
      (renewableVals.reduce((a, b) => a + b, 0) / renewableVals.length) * 100;
    const generatorRuntime = data.filter(
      (row) => get(row, "Generator Power Output") !== 0
    ).length;
    const fuelConsumption = data.reduce((sum, row) => {
      const value = get(row, "Generator Fuel");
      //console.log("Row log:", value);
      return sum + value;
    }, 0);

    return {
      solarPVCapacity: solarPVCapacity.toFixed(2),
      batteryStorageCapacity: batteryStorageCapacity.toFixed(2),
      batteryInverterCapacity: batteryInverterCapacity.toFixed(2),
      generatorSize: generatorSize.toFixed(2),
      renewableFraction: renewableFraction.toFixed(2),
      generatorRuntime,
      fuelConsumption: fuelConsumption.toFixed(2),
    };
  }

  const editOptimizationSummary = () => {
    setLoadingEditOptimizationSummary(true);
    const payload = {
      pv_tilt: PVTilt,
      pv_azimuth: PVAzimuth,
      solar_pv_capacity: solarPVCapacity,
      battery_storage_capacity: batteryStorageCapacity,
      battery_inverter_capacity: batteryInverterCapacity,
      generator_quantity: generatorQuantity,
      generator_size: generatorSize,
      model_renewable_fraction: renewableFraction,
      generator_runtime: generatorRuntime,
      fuel_consumption: fuelConsumption,
      fuel_tank_size: fuelTankSize,
    };

    fetch(`${Config.API.URL}/scenarios/${scenario?.id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        setLoadingEditOptimizationSummary(false);
        // if 401 error (unauthenticated user, then log user out)
        if (res.status === 401) {
          console.log("401 Error: Unauthenticated");
        }
        return res;
      })
      .then((res) => res.json())
      .then(async (res) => {
        setLoadingEditOptimizationSummary(false);

        // if request is succesful, alert user that project has been cloned
        if (res.status) {
          setScenario(res.data);
          setEditOptimizationSummaryModel(false);
        } else {
          //swal("Oh no!", res.message, "error");
        }
      })
      .catch((error) => {
        setLoadingEditOptimizationSummary(false);

        console.log("Error: ", error);
      });
  };

  const handleDownload = () => {
    // Create a link element, set the href to the file path in the public directory
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/sample-homer-optimization.csv`;
    link.setAttribute("download", "sample-homer-optimization.csv"); // Set the download attribute with the filename
    document.body.appendChild(link); // Append to the body
    link.click(); // Simulate click
    document.body.removeChild(link); // Remove the link element
  };

  useEffect(() => {
    if (productsData?.status) {
      const productMap = productsData.data;
      setProducts(productMap);

      const initialSelections = {};

      COMPONENT_KEYS.forEach((key) => {
        const products = productMap[key]?.data || [];
        const defaultNameKey = `${key.replace("-", "_")}_name`;
        const defaultProductName = DEFAULT_PRODUCT_NAMES[key];

        const defaultProduct =
          products.find((p) => p[defaultNameKey] === defaultProductName) ||
          products[0];

        if (defaultProduct) {
          let requiredCapacity = 1;
          if (key === "solar-product") requiredCapacity = solarPVCapacity;
          else if (key === "battery-product")
            requiredCapacity = batteryStorageCapacity;
          else if (key === "inverter-product")
            requiredCapacity = batteryInverterCapacity;
          else if (key === "generator-product")
            requiredCapacity = generatorSize;

          const quantity = calculateRequiredQuantity(
            defaultProduct,
            requiredCapacity,
            key
          );

          initialSelections[key] = {
            product: defaultProduct,
            quantity,
          };
        }
      });

      setSelections(initialSelections);
    }
  }, [
    productsData,
    solarPVCapacity,
    batteryStorageCapacity,
    batteryInverterCapacity,
    generatorSize,
  ]);

  return (
    <>
      <div className="bg-white rounded-[8px] p-6  mt-[90px] lg:mt-3 ">
        {microgridSystemSizingStage === 1 ? (
          <>
            <h2 className=" f-f-sm text-3xl text-black text-center ">
              Create A New Scenario
            </h2>
            <div className="2xl:px-20 ">
              <h2 className=" f-f-sm text-xl capitalize  text-primary  mt-10  text-center ">
                {" "}
                Microgrid Optimization Summary
              </h2>
              <div className="grid grid-cols-12  ">
                {/* .....................  Electric input started ..............*/}

                <div className=" col-span-12 lg:col-span-3 mt-5 ">
                  <h2 className=" f-f-r  xl:text-2xl text-xl  text-black-vlight mt-3 ">
                    Scenario Name <span className="text-primary">*</span>
                  </h2>
                </div>
                <div className=" col-span-12 lg:col-span-9 mt-5 ">
                  <input
                    type="text"
                    onChange={(e) => setScenarioName(e.target.value)}
                    value={scenarioName}
                    className=" w-full  h-[56px] border border-grey bg-white-dark rounded-[4px] px-4 outline-none  "
                  />
                </div>
              </div>

              <h2 className=" f-f-sm text-xl capitalize text-primary mt-10 text-center ">
                Microgrid System Sizing
              </h2>

              <div className=" mt-10 text-center  ">
                <ul className=" inline-flex  ">
                  <li className="p-2">
                    <button
                      onClick={() => setOptimizationType("HOMER")}
                      className={`${
                        optimizationType === "HOMER"
                          ? "bg-blue-950 border-blue-950 text-white"
                          : "bg-white border-primary text-gray"
                      } border text-lg f-f-r  w-[250px] h-[180px] rounded-[8px] captilize `}
                    >
                      Provide HOMER <br />
                      Optimization Results
                    </button>
                  </li>
                  <li className="p-2">
                    <button
                      onClick={() => setOptimizationType("NREL")}
                      className={`${
                        optimizationType === "NREL"
                          ? "bg-blue-950 border-blue-950 text-white"
                          : "bg-white border-primary text-gray"
                      } border text-lg f-f-r w-[250px] h-[180px] rounded-[8px] captilize `}
                    >
                      Use the Microgrid
                      <br />
                      Optimization feature
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="2xl:px-20 ">
              <h2 className=" f-f-sm text-xl capitalize  text-primary  mt-10  text-center ">
                {" "}
                Provide HOMER Optimization Results
              </h2>
              {/* Accordion started: Techno-economic Optimization */}
              <div className="mt-6">
                <div className="border border-gray-200 rounded-md divide-y divide-gray-200">
                  {/* Techno-economic Optimization Section */}
                  <button
                    className="w-full flex justify-between items-center px-4 py-3 font-semibold text-primary-dark bg-gray-100 hover:bg-gray-200"
                    onClick={() =>
                      setOpenSection((prev) =>
                        prev === "techno" ? null : "techno"
                      )
                    }
                  >
                    <span>Techno-economic Optimization</span>
                    {openSection === "techno" ? <FaMinus /> : <FaPlus />}
                  </button>
                  {openSection === "techno" && (
                    <div className="p-4 techno">
                      <div className="techno grid grid-cols-12 mt-5 gap-4  ">
                        <div
                          className={`   col-span-12 sm:col-span-${
                            scenario?.optimization_type !== "NREL" ? "6" : "12"
                          }`}
                        >
                          <div
                            className={` bg-white  shadow-lg p-[20px] rounded-[8px] mt-2 relative ${
                              scenario?.optimization_type !== "NREL"
                                ? ""
                                : "w-[700px]"
                            }  `}
                            style={{ marginLeft: "auto", marginRight: "auto" }}
                          >
                            <button
                              onClick={() =>
                                setEditOptimizationSummaryModel(true)
                              }
                              className="absolute top-3 right-3 border bg-primary w-[50px] text-center h-[30px] rounded-[15px] f-f-r text-sm text-white  "
                            >
                              Edit
                            </button>

                            <h2 className=" text-center f-f-sm text-lg text-black my-2  ">
                              Optimization Summary
                            </h2>
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Average PV Tilt
                              <span className=" float-right text-black ">
                                {PVTilt}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Average PV Azimuth
                              <span className=" float-right text-black ">
                                {PVAzimuth}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Solar PV Capacity (kW)
                              <span className=" float-right text-black ">
                                {solarPVCapacity}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Battery Storage Capacity (kWh)
                              <span className=" float-right text-black ">
                                {batteryStorageCapacity}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Battery Inverter Capacity (kW)
                              <span className=" float-right text-black ">
                                {batteryInverterCapacity}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Generator Quantity
                              <span className=" float-right text-black ">
                                {generatorQuantity}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Generator Size (kW)
                              <span className=" float-right text-black ">
                                {generatorSize}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Renewable Fraction (%)
                              <span className=" float-right text-black ">
                                {renewableFraction}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Generator Runtime (hours)
                              <span className=" float-right text-black ">
                                {generatorRuntime}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Fuel Consumption (gallons)
                              <span className=" float-right text-black ">
                                {fuelConsumption}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                            {/* start */}
                            <h3 className="  f-f-r text-lg text-black-vlight mt-2   ">
                              Fuel Tank Size (gallons)
                              <span className=" float-right text-black ">
                                {fuelTankSize}
                              </span>{" "}
                            </h3>
                            <div className=" border border-white-vlight my-1 "></div>
                          </div>
                        </div>

                        {scenario?.optimization_type !== "NREL" ? (
                          <div className={`   col-span-12 sm:col-span-6`}>
                            <div
                              className={` bg-white p-[20px] mt-2 relative `}
                            >
                              <h2 className=" f-f-sm text-xl capitalize text-primary mb-5 mt-5 text-center ">
                                Upload the Results of a HOMER Optimization
                              </h2>
                              {homer?.homer_hourly_summary?.length ? (
                                <>
                                  <p className=" f-f-sm mt-10 text-center ">
                                    Homer optimization file below
                                  </p>

                                  <div
                                    className=" mt-10 text-center "
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    <button
                                      style={{
                                        justifyContent: "center",
                                        display: "flex",
                                      }}
                                      className={`${
                                        false === "homer-optimization-results"
                                          ? "bg-blue-950 border-blue-950 text-white"
                                          : "bg-white border-primary text-gray"
                                      } border text-lg f-f-r  w-[400px] h-[130px] rounded-[8px] captilize `}
                                    >
                                      <img
                                        src={uploading ? Spinner : ExcelLogo}
                                        className="w-[45px] h-auto 2xl:w-[96px] text-center"
                                        style={{ alignSelf: "center" }}
                                        alt=""
                                      />
                                    </button>

                                    <button
                                      onClick={
                                        uploading
                                          ? () =>
                                              swal(
                                                "Please Wait!",
                                                "We're still uploading your HOMER file!",
                                                "info"
                                              )
                                          : triggerUploadHomer
                                      }
                                      className=" bg-primary text-lg f-f-r text-white  w-[400px] h-[48px] rounded-[8px] captilize mt-5"
                                    >
                                      {uploading &&
                                      parseInt(uploadProgress) < 100
                                        ? `Uploading`
                                        : "Update"}
                                    </button>

                                    {uploading &&
                                    parseInt(uploadProgress) < 100 ? (
                                      <p className=" f-f-sm text-center ">{`${uploadProgress}% - ${uploadReport}`}</p>
                                    ) : null}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <button
                                    onClick={
                                      uploading
                                        ? () =>
                                            swal(
                                              "Please Wait!",
                                              "Uploading HOMER file is on progress!",
                                              "info"
                                            )
                                        : triggerUploadHomer
                                    }
                                    className={`bg-blue-100 border-blue-950 text-black border text-lg f-f-r w-[100%] h-[300px] rounded-[8px] captilize `}
                                  >
                                    <img
                                      src={
                                        uploading &&
                                        parseInt(uploadProgress) < 100
                                          ? Spinner
                                          : uploading
                                          ? ExcelLogo
                                          : UploadIcon
                                      }
                                      className="w-[45px] h-auto 2xl:w-[96px] text-center"
                                      style={{
                                        marginLeft: "auto",
                                        margin: "auto",
                                      }}
                                      alt=""
                                    />
                                    <p className="mt-2">
                                      {uploading &&
                                      parseInt(uploadProgress) < 100
                                        ? `${uploadProgress}% - ${uploadReport}`
                                        : uploading
                                        ? "Upload successful! We're processing your file now. You may proceed"
                                        : "Choose a file"}
                                    </p>
                                  </button>
                                  {parseInt(uploadProgress) < 100 && (
                                    <p
                                      className=" f-f-sm mb-5 mt-5 text-center cursor-pointer "
                                      onClick={handleDownload}
                                    >
                                      Click here to download a sample HOMER
                                      Optimization file
                                    </p>
                                  )}
                                  {parseInt(uploadProgress) < 100 && (
                                    <div style={{ textAlign: "center" }}>
                                      <button
                                        onClick={() =>
                                          setFileUploadInstructionsModel(true)
                                        }
                                        className="border bg-primary w-[250px] h-[50px] rounded-[15px] f-f-r text-lg text-white text-center"
                                      >
                                        File Upload Instructions
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  )}

                  {/* Hardware KIT Recommendation Section */}
                  <button
                    className="w-full flex justify-between items-center px-4 py-3 font-semibold text-primary-dark bg-gray-100 hover:bg-gray-200"
                    onClick={() =>
                      setOpenSection((prev) =>
                        prev === "hardware" ? null : "hardware"
                      )
                    }
                  >
                    <span>Hardware KIT Recommendation</span>
                    {openSection === "hardware" ? <FaMinus /> : <FaPlus />}
                  </button>
                  {openSection === "hardware" && (
                    <div className="p-4 hardware">
                      <div className="max-w-7xl mx-auto p-4">
                        <h2 className="text-xl font-semibold text-center text-primary-dark mb-6">
                          Recommended Product Kits: Customize selections via
                          dropdowns
                        </h2>
                        <div className="overflow-x-auto">
                          <table className="min-w-full table-auto border border-gray-200 shadow-md rounded">
                            <thead className="bg-gray-100 text-gray-700">
                              <tr>
                                <th className="px-4 py-2 border">Component</th>
                                <th className="px-4 py-2 border">
                                  Product Choice
                                </th>
                                <th className="px-4 py-2 border">
                                  Unit Capacity
                                </th>
                                <th className="px-4 py-2 border">Quantity</th>
                                <th className="px-4 py-2 border">
                                  Total Capacity
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {COMPONENT_KEYS.map((category) => {
                                const entry = selections[category];
                                const unitCapacity =
                                  entry?.product?.[
                                    `${category.replace(
                                      "-",
                                      "_"
                                    )}_unit_capacity`
                                  ] || 0;
                                const quantity = entry?.quantity || 1;
                                const total = unitCapacity * quantity;
                                return (
                                  <tr key={category} className="border-t">
                                    <td className="px-4 py-2 border">
                                      {COMPONENT_LABELS[category]}
                                    </td>
                                    <td className="px-4 py-2 border">
                                      <select
                                        className="w-full border rounded p-1"
                                        value={entry?.product?.id || ""}
                                        onChange={(e) =>
                                          handleProductChange(
                                            category,
                                            e.target.value
                                          )
                                        }
                                      >
                                        {(products[category]?.data || []).map(
                                          (p) => (
                                            <option key={p.id} value={p.id}>
                                              {
                                                p[
                                                  `${category.replace(
                                                    "-",
                                                    "_"
                                                  )}_name`
                                                ]
                                              }
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </td>
                                    <td className="px-4 py-2 border text-center">
                                      {unitCapacity}
                                    </td>
                                    <td className="px-4 py-2 border text-center">
                                      <input
                                        type="number"
                                        min={1}
                                        className="w-20 border rounded p-1 text-center"
                                        value={quantity}
                                        onChange={(e) =>
                                          handleQuantityChange(
                                            category,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td className="px-4 py-2 border text-center">
                                      {total.toFixed(1)} {UNIT_LABELS[category]}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        {/* <div className="mt-6 text-center">
                          <button
                            onClick={handleSave}
                            className="bg-primary hover:bg-blue-700 text-white font-bold py-2 px-6 rounded"
                          >
                            Save
                          </button>
                        </div> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <div className=" mt-10 text-end  ">
          <ul className=" inline-flex  ">
            <li>
              {loading ? (
                <button className=" bg-gray text-lg f-f-r text-gray  w-[127px] h-[48px] rounded-[8px] captilize ">
                  Loading...
                </button>
              ) : (
                <button
                  onClick={() => {
                    if (microgridSystemSizingStage === 1) {
                      submitScenarios();
                    } else {
                      handleSave();
                    }
                  }}
                  className="bg-primary text-lg f-f-r text-white w-[127px] h-[48px] rounded-[8px] capitalize"
                >
                  {storing ? "Loading..." : "Done"}
                </button>
              )}
            </li>
            <li className=" ml-6 ">
              <button
                onClick={() => navigate(-1)}
                className=" border border-primary text-lg f-f-r text-primary  w-[127px] h-[48px] rounded-[8px] captilize "
              >
                Back
              </button>
            </li>
          </ul>
        </div>
        <input
          type="file"
          id="upload-homer-file"
          accept=".csv"
          onChange={uploadHomer}
          style={{ display: "none" }}
          ref={homer_file}
        />
      </div>

      <Transition.Root show={editOptimizationSummaryModel} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setEditOptimizationSummaryModel}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Edit Optimization Summary
                        </Dialog.Title>
                        <div className="mt-2" style={{ width: "100%" }}>
                          <form>
                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Average PV Tilt
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) => setPVTilt(e.target.value)}
                                    value={PVTilt}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Average PV Azimuth
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setPVAzimuth(e.target.value)
                                    }
                                    value={PVAzimuth}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Solar PV Capacity (kW)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setSolarPVCapacity(e.target.value)
                                    }
                                    value={solarPVCapacity}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Battery Storage Capacity (kWh)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setBatteryStorageCapacity(e.target.value)
                                    }
                                    value={batteryStorageCapacity}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Battery Inverter Capacity (kW)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setBatteryInverterCapacity(e.target.value)
                                    }
                                    value={batteryInverterCapacity}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Generator Quantity
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setGeneratorQuantity(e.target.value)
                                    }
                                    value={generatorQuantity}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Generator Size (kW)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setGeneratorSize(e.target.value)
                                    }
                                    value={generatorSize}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Renewable Fraction (%)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setRenewableFraction(e.target.value)
                                    }
                                    value={renewableFraction}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Generator Runtime (hours)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setGeneratorRuntime(e.target.value)
                                    }
                                    value={generatorRuntime}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Fuel Consumption (gallons)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setFuelConsumption(e.target.value)
                                    }
                                    value={fuelConsumption}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                  Fuel Tank Size (gallons)
                                </label>
                                <div className="mt-0">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      setFuelTankSize(e.target.value)
                                    }
                                    value={fuelTankSize}
                                    className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    {loadingEditOptimizationSummary ? (
                      <button className=" inline-flex w-full justify-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto ">
                        Loading...
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto"
                        onClick={editOptimizationSummary}
                      >
                        Save
                      </button>
                    )}
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => setEditOptimizationSummaryModel(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={fileUploadInstructionsModel} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setFileUploadInstructionsModel}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:text-left">
                        {/* <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Edit Optimization Summary
                        </Dialog.Title> */}
                        <div className="mt-2" style={{ width: "100%" }}>
                          <form>
                            <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                              <div className="col-span-full">
                                <label className="block text-lg font-medium leading-6 text-gray-900">
                                  To ensure accurate extraction of optimization
                                  result from your HOMER file, rename the
                                  components using the following mapping before
                                  uploading;
                                </label>
                                <div className="mt-5 pl-10 mb-5">
                                  <ul className="list-disc">
                                    <li>PV components {"->"} Solar </li>
                                    <li>
                                      Generator component {"->"} Generator{" "}
                                    </li>
                                    <li>Converter component {"->"} Inverter</li>
                                    <li>Storage component {"->"} Battery</li>
                                  </ul>
                                </div>

                                <label className="block text-lg font-medium leading-6 text-gray-900">
                                  This step helps avoid confusion, especially
                                  when components from the same manufacturer
                                  have similar names.
                                </label>
                              </div>
                            </div>
                          </form>

                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => setFileUploadInstructionsModel(false)}
                      ref={cancelButtonRef}
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
